/**
 * Saves the given file name to localStorage.
 *
 * This function stores the specified `fileName` under the key `doc_original_file_name` in the browser's localStorage.
 * It can be used to persist the file name for future access.
 *
 * @function saveFileNameToLocalStorage
 * @param {string} fileName - The name of the file to be saved in localStorage.
 * @returns {void}
 */
export const saveFileNameToLocalStorage = (fileName: string): void => {
  localStorage.setItem('doc_original_file_name', fileName);
};
